import React, { forwardRef } from 'react';
import PropTypes from 'prop-types';

const Grid = forwardRef(({ children, className, ulStyle = {} }, ref) => (
  <ul
    style={ulStyle}
    ref={ref}
    className={className || 'grid grid-5-col'}
  >
    {children}
  </ul>
));

Grid.propTypes = {
  ulStyle: PropTypes.shape(),

  children: PropTypes.arrayOf(PropTypes.shape()),
  className: PropTypes.string,
};

export default Grid;
